import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from "styled-components";


const CarouselSec = () => {
  return (
    <Wrapper>

      <Carousel fade>
        <Carousel.Item >
          <img className="d-block w-100" src="images/crousel-1.jpg" alt="First slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src="images/crousel-2.jpg" alt="Second slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src="images/crousel-3.jpg" alt="Third slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src="images/crousel-4.jpg" alt="Fourth slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src="images/crousel-5.jpg" alt="Fifth slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src="images/crousel-6.jpg" alt="Sixth slide" />
        </Carousel.Item>
      </Carousel>


      <div className="grid grid-four-column carousel-four-col">
        <div className="outer">
          <h3>Keep shoping</h3>
          <div className="grid grid-two-column">
            <div className='p-2 product-sec'>
              <img src="images/battery-1.jpg" alt="" />
              <p className='mt-3'>ENVIE® (AA2100RT…</p>
            </div>
            <div className='p-2 product-sec'>
              <img src="images/batterybig.jpg" alt="" />
              <p className='mt-3'>ENVIE® (AA2100RT…</p>
            </div>

          </div>
          <div className="grid grid-two-column">
            <div className='p-2 product-sec'>
              <img src="images/stepupmodule.jpg" alt="" />
              <p className='mt-3'>Allianztec 150W…</p>
            </div>
            <div className='p-2 product-sec'>
              <img src="images/modulestepup.jpg" alt="" />
              <p className='mt-3'>Generic PZIN140…</p>
            </div>

          </div>
        </div>
        <div className="outer">
          <h3>Shop & Pay | Earn rewards daily</h3>
          <div className="grid grid-two-column">
            <div className='p-2 product-sec'>
              <img src="images/Bus-3.jpg" alt="" />
              <p className='mt-3'>ENVIE® (AA2100RT…</p>
            </div>
            <div className='p-2 product-sec'>
              <img src="images/flight-1.jpg" alt="" />
              <p className='mt-3'>ENVIE® (AA2100RT…</p>
            </div>

          </div>
          <div className="grid grid-two-column">
            <div className='p-2 product-sec'>
              <img src="images/stepupmodule.jpg" alt="" />
              <p className='mt-3'>Allianztec 150W…</p>
            </div>
            <div className='p-2 product-sec'>
              <img src="images/modulestepup.jpg" alt="" />
              <p className='mt-3'>Generic PZIN140…</p>
            </div>
          </div>
          <h4>Order Now</h4>
        </div>
        <div className="outer">
          <h3>Pick up where you left off</h3>
          <div className="grid grid-two-column">
            <div className='p-2 product-sec'>
              <img src="images/arrowjacket.jpg" alt="" />
              <p className='mt-3'>ENVIE® (AA2100RT…</p>
            </div>
            <div className='p-2 product-sec'>
              <img src="images/penlighter.jpg" alt="" />
              <p className='mt-3'>ENVIE® (AA2100RT…</p>
            </div>

          </div>
          <div className="grid grid-two-column">
            <div className='p-2 product-sec'>
              <img src="images/cilli.jpg" alt="" />
              <p className='mt-3'>Allianztec 150W…</p>
            </div>
            <div className='p-2 product-sec'>
              <img src="images/battery.jpg" alt="" />
              <p className='mt-3'>Generic PZIN140…</p>
            </div>

          </div>
        </div>

        <div className="outer">
          <div className="upper-sec d-flex">
            <div>
              <p>Become an CartFo seller</p>
              <a href="/#">Register now</a>
            </div>
            <div className='img-sec'>
              <img src="images/amazon-sellerf.jpg" alt="" />
            </div>


          </div>
          <div className="lower-sec">
            <img src="images/laptop.jpg" alt="" />
          </div>
        </div>

      </div>





    </Wrapper>

  )
}


const Wrapper = styled.section`
.carousel-inner:after {
  background: linear-gradient(-180deg,rgba(234,237,237,0),#eaeded);
  bottom: -10px;
  content: "";
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 250px;
  z-index: 1;
}



a.carousel-control-prev, a.carousel-control-next {
  bottom: 50%;
}
.carousel-indicators {
  display: none;
}
// .carousel-four-col{

// }

.grid-four-column{
  grid-template-columns: repeat(4, 1fr);
  gap:2rem;
  padding: 2rem;
  background: #eaeded;
  
  
  .outer{
    margin-top:-85%;
    background:white;
    z-index:99;
    height:400px;
    padding:20px;
    

    h3{
      font-size:2.8rem;
      font-weight:600;
    }
    p{
      font-size:1.2rem;
    }
    .product-sec{
      padding:10px;
      text-align:center;
      img{
        max-width: 100px;
      }
    }
    .grid{
      gap:initial;
    }
  }
  .outer:last-child{
    background:transparent;
    padding:0px;
    
    .upper-sec{
      background:white;
      height:32%;
      padding: 3rem;
      justify-content: space-between;

      p {
        font-size: 2rem;
        font-weight: 600;
        line-height: 1.3;
      }
      a{
        font-size: 1.2rem;
      }

      .img-sec{
        width:80px;
        img{
          width:inherit;
        }
      }
    }
    .lower-sec{
      // background:white;
      // height:60%;
      position:relative;
      bottom:-2rem;
      text-align: center;
    }

  }


}




@media (max-width: ${({ theme }) => theme.media.mobile}) {
.carousel-four-col{
  grid-template-columns: repeat(1, 1fr);
  margin-top: -25%;

.outer{
  margin-top:0;
  p{
    font-size:1.9rem;
  }

    .upper-sec  {
      p{
      font-size:3rem !important;
      }
      a{
        font-size: 1.5rem !important;
      }

  }
}  
  .grid-two-column {
    grid-template-columns: repeat(2,1fr);
}
}





.carousel-inner:after {
  bottom: 0px;
  top: 0px;
}


}


`;

export default CarouselSec